module.exports = __webpack_public_path__ + "assets/img/IMG034.c5dff53c.png";